const state = {
  canEditReferenceData: false,
  referenceLookups: {},
  moves: [],
  referenceData: {},
  pokemonCatalog: [],
  rows: [],
  workflowBatches: [],
  workflowChangelog: [],
  canUploadReady: false,
  usageRanks: [],
  referenceDataUpdatedAt: null,
  workflowUpdatedAt: null,
  updatedAt: null
}

const getters = {
  spawnCanEditReferenceData: state => state.canEditReferenceData,
  spawnReferenceLookups: state => state.referenceLookups,
  spawnMoves: state => state.moves,
  spawnPokemonCatalog: state => state.pokemonCatalog,
  spawnReferenceData: state => state.referenceData,
  spawnReferenceDataUpdatedAt: state => state.referenceDataUpdatedAt,
  spawnWorkflowBatches: state => state.workflowBatches,
  spawnWorkflowChangelog: state => state.workflowChangelog,
  spawnWorkflowCanUploadReady: state => state.canUploadReady,
  spawnWorkflowUpdatedAt: state => state.workflowUpdatedAt,
  spawnUsageRanks: state => state.usageRanks,
  spawns: state => state.rows,
  spawnsUpdatedAt: state => state.updatedAt
}

const actions = {
  getSpawns ({ commit }, payload) {
    commit('setSpawns', payload && payload.data ? payload.data : [])
  },
  getSpawnReferenceData ({ commit }, payload) {
    commit('setSpawnReferenceData', payload && payload.data ? payload.data : {})
  },
  getSpawnEditorWorkflow ({ commit }, payload) {
    commit('setSpawnEditorWorkflow', payload && payload.data ? payload.data : {})
  }
}

const mutations = {
  setSpawnReferenceData (state, payload) {
    state.referenceData = payload.referenceData || {}
    state.referenceLookups = payload.lookups || {}
    if (Object.prototype.hasOwnProperty.call(payload, 'moves')) {
      state.moves = Array.isArray(payload.moves) ? payload.moves : []
    }
    if (Object.prototype.hasOwnProperty.call(payload, 'usageRanks')) {
      state.usageRanks = Array.isArray(payload.usageRanks) ? payload.usageRanks : []
    }
    if (Object.prototype.hasOwnProperty.call(payload, 'pokemonCatalog')) {
      state.pokemonCatalog = Array.isArray(payload.pokemonCatalog) ? payload.pokemonCatalog : []
    }
    state.canEditReferenceData = !!payload.canEdit
    state.referenceDataUpdatedAt = new Date().toISOString()
  },
  setSpawnEditorWorkflow (state, payload) {
    state.workflowBatches = Array.isArray(payload.batches) ? payload.batches : []
    state.workflowChangelog = Array.isArray(payload.changelog) ? payload.changelog : []
    state.canUploadReady = !!payload.canUploadReady
    state.workflowUpdatedAt = new Date().toISOString()
  },
  setSpawns (state, rows) {
    state.rows = Array.isArray(rows) ? rows : []
    state.updatedAt = new Date().toISOString()
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
